import { cfetch } from '@confluence/network';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures';
import { fg } from '@confluence/feature-gating';
import { isLocal } from '@confluence/ssr-utilities/entry-points/env';

import { LocalStorageQuery } from './LocalStorageQueryRaw';
import { getKeysForLocalStorageQuery } from './storageHelpers';
import type { LocalStorageQueryVariables } from './__types__/LocalStorageQuery';
import type { StorageManagerInitContext } from './StorageManagerInitContext';

export async function getRemoteLocalStorage({
	userId,
	isLicensed,
}: StorageManagerInitContext): Promise<any> {
	if (window['__REMOTE_LOCAL_STORAGE__']) {
		return window['__REMOTE_LOCAL_STORAGE__'];
	}

	const URI = fg('cc-agg-migration-use-agg-endpoint')
		? '/gateway/api/graphql/slow'
		: window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
	return (window['__REMOTE_LOCAL_STORAGE__'] = SSRMeasures.run(
		'ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery',
		async () => {
			let result = null;
			try {
				if (isLicensed && userId) {
					const variables: LocalStorageQueryVariables = {
						stringKeys: getKeysForLocalStorageQuery(userId),
					};

					const res = await cfetch(`${URI}?q=LocalStorageQuery`, {
						method: 'POST',
						credentials: 'include',
						headers: {
							'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
							'Content-Type': 'application/json',
							// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
							...(Boolean(process.env.REACT_SSR) &&
							Boolean(process.env.BIFROST_TEMPLATE_BUILD) &&
							!isLocal()
								? { 'x-ssr-asap-audience': 'cc-graphql' }
								: {}),
						},
						body: JSON.stringify({
							operationName: 'LocalStorageQuery',
							query: LocalStorageQuery,
							variables,
						}),
					});
					if (res.ok) {
						const { data } = await res.json();
						result = data?.localStorage?.stringValues;
					}
				}
			} catch (e) {}
			return (window['__REMOTE_LOCAL_STORAGE__'] = result);
		},
	));
}
